module.exports = __webpack_public_path__ + "static/media/layout5-vid.ddb19a9a.svg";